module.exports = __webpack_public_path__ + "static/media/map_pin_int_gray.72d7f805.svg";